import { type FlavorsSelection } from "@jti/fe-common";
import type { IBundleOptionInput, IMultiselectQuantity } from "@jti/magento";

const getFlavorSelectionQuantitiesPayload = (flavorsSelection: FlavorsSelection): IMultiselectQuantity[] => {
  return Object.entries(flavorsSelection).map(([key, value]) => {
    return {
      qty: [value],
      selection_id: [Number(key)],
    };
  });
};

export const getBundleProductCartPayload = (
  itemId: number,
  flavorsSelection: FlavorsSelection | undefined = {}
): IBundleOptionInput[] => {
  return [
    {
      id: itemId,
      quantities: Object.keys(flavorsSelection).length > 0 ? getFlavorSelectionQuantitiesPayload(flavorsSelection) : [],
      quantity: 0, // Nobody knows what this value stands for, but it's better to leave it hardcoded value zero
      value: Object.keys(flavorsSelection),
    },
  ];
};
